import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, Sparkles } from "lucide-react";

/**
 * Highly-visible primary CTA that takes the user to the chat surface where
 * they can compose their first prompt. The chat record itself is created
 * ONLY on first message send (see Chat.jsx), so clicking this button NEVER
 * produces an empty chat in the history.
 */
export default function NewChatButton({ compact = false }) {
    const navigate = useNavigate();
    const [clicked, setClicked] = useState(false);

    const onClick = () => {
        setClicked(true);
        // Fire the global reset BEFORE navigating so the Chat component
        // remounts with fresh state even when we're already on /chats.
        window.dispatchEvent(new CustomEvent("kc:new-chat-requested"));
        navigate("/chats");
        // small reset so another quick click still animates
        window.setTimeout(() => setClicked(false), 400);
    };

    return (
        <button
            data-testid="new-chat-btn"
            onClick={onClick}
            title="Ir al chat para crear uno nuevo"
            className={`group relative inline-flex items-center gap-2 rounded-full bg-periwinkle-500 hover:bg-periwinkle-400 text-ink-950 font-medium shadow-glow-sm hover:shadow-glow transition-all duration-200 ${
                compact ? "h-9 px-3 text-xs" : "h-10 px-4 text-sm"
            } ${clicked ? "scale-95" : ""}`}
        >
            <span className="relative flex items-center justify-center">
                <Plus
                    className={`${compact ? "w-3.5 h-3.5" : "w-4 h-4"} transition-transform group-hover:rotate-90 duration-300`}
                />
            </span>
            <span className="font-display tracking-tight">Nuevo chat</span>
            <Sparkles
                className={`${compact ? "w-3 h-3" : "w-3.5 h-3.5"} opacity-70 group-hover:opacity-100 animate-pulse-soft`}
            />
        </button>
    );
}
